module.exports = __webpack_public_path__ + "static/media/ice19.38baf275.webp";